import { Component, HostListener, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {ToastrService} from 'ngx-toastr';
import Utils from '../utils/utils';
import {AccountService} from '../core/auth/account.service';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { DefaultClassDirective } from '@ngbracket/ngx-layout/extended';
import { DefaultLayoutDirective } from '@ngbracket/ngx-layout/flex';
import { MatIcon } from '@angular/material/icon';
import { MatNavList, MatListItem } from '@angular/material/list';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    imports: [MatToolbar, DefaultClassDirective, MatToolbarRow, DefaultLayoutDirective, RouterLink, MatIcon, MatNavList, MatListItem, MatTooltip, RouterOutlet]
})
export class HomeComponent implements OnInit {
  router = inject(Router);
  private http = inject(HttpClient);
  private toastr = inject(ToastrService);
  private accountService = inject(AccountService);


  amount: string;
  isLoading = true;
  error = false;
  home = true;
  apiUrl = environment.apiUrl;
  showAccountMenu = false;
  activeClick = 0;
  showSidenavMenu = true;
  showMenuSummary = false;
  showMenuBills = false;
  showMenuSwitchCompany = false;
  showMenuMandat = false;
  showMenuLogin = false;
  showMenuRegister = false;
  showMenuResetPassword = false;
  hotfixShowMenu = true;
  innerWidth: number;

  constructor() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 500) {
      this.showSidenavMenu = false;
    }
    this.router.events.subscribe(e => {
        if (e instanceof NavigationEnd) {
          if (e.url.includes('/paiement') || e.url.includes('/switch-company')) {
            this.accountService.identity().then((authenticated) => {
              this.hotfixShowMenu = authenticated;
            });
          }
        }
      }
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.innerWidth = window.innerWidth;
  }

  @HostListener('document:click')
  documentClick(): void {
    this.activeClick = this.activeClick + 1;
    if (this.activeClick !== 1) {
      this.showAccountMenu = false;
      if (this.innerWidth < 500) {
        this.showSidenavMenu = false;
      }
    }
  }

  ngOnInit(): void {
    this.accountService.identity().then((authenticated) => {
      if (!authenticated) {
        Utils.cleanLocalStorage();
      }
    });
  }

  logout(): void {
    this.accountService.disconnect();
    this.router.navigate(['login']).then();
  }

  clickAccountMenu(): void {
    this.showAccountMenu = !this.showAccountMenu;
    if (this.showAccountMenu) {
      this.activeClick = 0;
    }
  }

  clickLateralMenu(): void {
    this.showSidenavMenu = !this.showSidenavMenu;
    if (this.showSidenavMenu) {
      this.activeClick = 0;
    }
  }

  isAuthenticated(): boolean {
    return this.accountService.isAuthenticated();
  }

  tiersSelected(): boolean {
    return localStorage.getItem('tiers') !== null && localStorage.getItem('tiers') !== 'undefined';
  }

  activeModuleMandat(): boolean {
    return this.accountService.canUseMandat();
  }

  activatedAccount(): boolean {
    return localStorage.getItem('activated') != null ? localStorage.getItem('activated') === 'true' : true;
  }
}
